module.exports = __webpack_public_path__ + "img/537.cee9724c.jpg";